import { SxProps, Theme } from "@mui/material";

export const footerContentStyles: SxProps<Theme> = {
    mb: 6,
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 3,
};

export const hsvDiamondLogo: SxProps<Theme> = {
    height: "auto",
    maxWidth: "50px",
};

export const footerLogoStyles: SxProps<Theme> = {
    width: "300px",
};

export const footerLink: SxProps<Theme> = (theme) => ({
    color: theme.palette.common.white,
    fontFamily: "HsvSans",
    fontSize: "0.875rem",
    textTransform: "uppercase",
    textDecoration: "none",
    "&:hover": {
        textDecoration: "underline",
    },
});

export const footerLinksContainer: SxProps<Theme> = {
    display: "flex",
    gap: "20px",
    mt: 1,
    mb: 2,
};

export const consentLink: SxProps<Theme> = (theme) => ({
    ...footerLink(theme),
    textTransform: "none",
    fontSize: "0.8rem",
});
